module.exports = require("assert");


//////////////////
// WEBPACK FOOTER
// external "assert"
// module id = 27
// module chunks = 0